import { render } from "./CharlaBackground.vue?vue&type=template&id=a00f67c2&scoped=true"
import script from "./CharlaBackground.vue?vue&type=script&lang=js"
export * from "./CharlaBackground.vue?vue&type=script&lang=js"

import "./CharlaBackground.vue?vue&type=style&index=0&id=a00f67c2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a00f67c2"]])

export default __exports__